import { env } from "../datas.config";

export async function changeImage(user, formData) {
  try {
    const res = await fetch(
      `${env.domain}/api/auth/images/my-profile/change-image`,
      {
        method: "put",
        body: formData,
        credentials: "include",
      }
    );
    return await res.json();
  } catch (err) {
    console.error("Erreur changement image:", err);
    return null;
  }
}

export async function deleteImage() {
  try {
    const res = await fetch(
      `${env.domain}/api/auth/images/my-profile/delete-image`,
      { method: "delete", credentials: "include" }
    );
    return await res.json();
  } catch (err) {
    console.error("Erreur suppression image:", err);
    return null;
  }
}

export function changePassword(user, password, setMessageFromApi) {
  const options = {
    headers: {
      "Content-Type": "application/json",
    },
    method: "put",
    body: JSON.stringify({ password, userId: user.userId }),
    credentials: "include",
  };
  fetch(`${env.domain}/api/auth/my-profile/change-password`, options)
    .then((res) => {
      return res.json();
    })
    .then((value) => {
      console.clear();
      setMessageFromApi(value);
    })
    .catch((err) => {
      console.clear();
      console.error(err.toString());
    });
}
